module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('div', {
    staticClass: "cross"
  }, [_c('p', {
    staticClass: "body"
  }, [_c('br')]), _vm._v(" "), _c('h1', {
    staticClass: "part-number---IVP",
    attrs: {
      "title": "Part 2: Cruciformation: Worship in the Way of the Cross"
    }
  }, [_c('span', {
    staticClass: "text_color"
  }, [_vm._v("Part 2")])]), _vm._v(" "), _c('h2', {
    staticClass: "part-title---IVP sigil_not_in_toc",
    attrs: {
      "id": "_idParaDest-8",
      "title": "Cruciformation: Worship in the Way of the Cross"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor072"
    }
  }), _c('br'), _c('br'), _c('span', {
    staticClass: "large"
  }, [_vm._v("Cruciformation")])]), _vm._v(" "), _c('h3', {
    staticClass: "part-sub sigil_not_in_toc"
  }, [_vm._v("Worship in the Way of the Cross")]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page32",
      "title": "32"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66a01b4f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/part2.vue
// module id = 78
// module chunks = 0